import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {CurrentUserAdapter} from '@drl/core/auth/adapters/current-user-adapter.service';
import * as moment from 'moment';

import {AlertNotification} from '../models/notification.model';
import {NotificationAdapter} from './notification-adapter.service';

@Injectable()
export class AlertNotifAdapter implements IAdapter<AlertNotification> {
  constructor(
    private readonly notifAdapter: NotificationAdapter,
    private readonly userAdapter: CurrentUserAdapter,
  ) {}

  adaptToModel(resp: any): AlertNotification {
    const notif: AlertNotification = new AlertNotification();
    Object.assign(notif, this.notifAdapter.adaptToModel(resp));
    notif.notificationTime = moment(new Date(notif.sent)).fromNow();
    if (resp.options && resp.options.patient) {
      notif.patient = this.userAdapter.adaptToModel(resp.options.patient);
      notif.messageTitle = notif.patient.fullName || notif.messageTitle;
     
      notif.messageBody = `${notif.body} ${moment(
        new Date(notif.sent),
      ).fromNow()}`;
      notif.photo = notif.patient.photo || notif.photo;
    }
    if (resp.options && resp.options.alertId) {
      notif.alertId = resp.options.alertId;
    }
    return notif;
  }

  adaptFromModel(data: AlertNotification): any {
    return data;
  }
}
